import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puz34 = () => {
    return (
        <div>
            <NavLink to='/category/Puzzels/Puzzel35'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel33'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article class="content post-142650 post type-post status-publish format-standard hentry category-puzzles"
    id="post-142650">
    <div class="title">Prisoner and Policeman Puzzle</div>
    
    <div class="text">
        <p>Policeman decided to punish the Prisoner and asked him to make a statement. The Prisoner should make such a
            statement so that he would be alive.<br/>If the statement is held true by Policeman, the Prisoner will be
            hanged to death and if the statement is held false, the Prisoner will be shot dead.</p>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
        <div class="containers">
        <p>Answer:<br/>The Prisoner said, ‘I will be shot dead’<br/>If Policeman says the statement is true, the Prisoner
            will be hanged to death which will make his statement false.<br/>If Policeman says the statement is false,
            the Prisoner will be shot dead which will make the statement true.</p>
       </div>
    </div>
</article>
        </div>
    )
}

export default Puz34
